import { Datepicker } from "vanillajs-datepicker";

const nodeDatepicker = document.querySelectorAll(".form-field--datepicker");

const optionsMonth = {
    format: "mm/yyyy",
    pickLevel: 1,
};

const optionsDays = {
    format: "mm/dd/yyyy",
    pickLevel: 0,
};

try {
    if (nodeDatepicker.length) {
        nodeDatepicker.forEach((nodeSelector) => {
            let datepicker = null;
            const input = nodeSelector.querySelector("input");
            const button = nodeSelector.querySelector("button");
            if (input && input.readOnly) {
                return;
            }
            if (input) {
                if (input.dataset.pick === "month") {
                    datepicker = new Datepicker(input, optionsMonth);
                } else {
                    datepicker = new Datepicker(input, optionsDays);
                }
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        });
    }
} catch (err) {
    console.error(err);
}
